module.exports = __webpack_public_path__ + "img/pic_3_zh.c89e8b5c.png";